import { graphql } from 'react-relay';

export const datepickerFragment = graphql`
    fragment Datepicker_text on PerformanceOverviewDatepicker {
        presetdatetexts
        headercols
        savebuttontext
    }
`;
